import nativeApi from './nativeApi';
import generateRandomId from './random-id';
import localStorage from './localStorage';
import env from './env';

const cache = env.isNative ? getFromNative() : getFromCache();

function getFromNative() {
  return nativeApi.invoke('getDeviceInfo')
    .then(r => {
      const deviceInfo = {
        inApp: true,
        os: env.os,
        name: r.name,
        p: r.p,
        version: r.version,
        // 由于各种乱七八糟的客户端版本，现在唯一可行的获取uid的方法是从URL上获取uid
        // 仅当在App里面时window.UID才有效
        uid: r.uid || window.UID,
        uuid: r.uuid,
        imei: r.imei
      };
      localStorage.set('gtgj.deviceInfo', deviceInfo);
      return deviceInfo;
    }, () => {
      return getFromCache();
    });
}

function getFromCache() {
  let cacheDeviceInfo = localStorage.get('gtgj.deviceInfo');

  if (!(cacheDeviceInfo && cacheDeviceInfo.uid && cacheDeviceInfo.uid.indexOf('H5GT') >= 0)) {
    const randomId = generateRandomId();

    cacheDeviceInfo = {
      inApp: false,
      os: env.os,
      uid: randomId,
      uuid: randomId,
      imei: randomId,
    };
    localStorage.set('gtgj.deviceInfo', cacheDeviceInfo);
  }

  return Promise.resolve(cacheDeviceInfo);
}

export default {
  get() {
    return cache;
  }
};



// WEBPACK FOOTER //
// ./src/utils/device.js